module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_103-d3ec751b23351e6ef07504a769675f7e.png";